export function colorToRGBA(color) {
  let rgba;

  if (color.charAt(0) === '#') {
    color = color.slice(1);
  }

  if (color.length === 6) {
    rgba = _.map(color.match(/../g), pair => parseInt(pair, 16));
    rgba.push(1);
    return rgba;
  }

  if (color.length === 3) {
    rgba = _.map(color.match(/./g), pair => parseInt(pair + pair, 16));
    rgba.push(1);
    return rgba;
  }

  rgba = _(color)
    .replace(/^rgba?\(/, '')
    .replace(/\)$/, '')
    .split(',')
    .map(value => Number(value));

  if (rgba.length === 3) {
    rgba.push(1);
  }

  return rgba;

}

export function makeRGBA(color, opacity) {
  const colorRGBA = colorToRGBA(color);
  colorRGBA[3] = (_.isFunction(opacity) ? opacity(colorRGBA[3]) : opacity).toFixed(2);
  return `rgba(${colorRGBA.join(',')})`;
}

/**
 * Converts an HSL color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes h, s, and l are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   {number}  h       The hue
 * @param   {number}  s       The saturation
 * @param   {number}  l       The lightness
 * @return  {Array}           The RGB representation
 */
function hslToRgb(h, s, l) {
  let r;
  let g;
  let b;

  function hue2rgb(p, q, t) {
    if (t < 0) {
      t += 1;
    }
    if (t > 1) {
      t -= 1;
    }
    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }
    if (t < 1 / 2) {
      return q;
    }
    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
  }

  if (s === 0) {
    // achromatic
    r = g = b = l;
  } else {

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

/**
 * Converts an RGB color value to HSL. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes r, g, and b are contained in the set [0, 255] and
 * returns h, s, and l in the set [0, 1].
 *
 * @param   {number}  r       The red color value
 * @param   {number}  g       The green color value
 * @param   {number}  b       The blue color value
 * @return  {Array}           The HSL representation
 */
function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h;
  let s;
  const l = (max + min) / 2;

  if (max === min) {
    // achromatic
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }

  return [h, s, l];
}

export function isLight(color) {
  const [r, g, b] = colorToRGBA(color);
  const [, , lightness] = rgbToHsl(r, g, b);
  return lightness < 0.25;
}

function lightenDarken(color, percent) {
  const [r, g, b] = colorToRGBA(color);
  const [h, s, l] = rgbToHsl(r, g, b);
  return `rgb(${hslToRgb(h, s, l - l * percent / 100).join(',')})`;
}

export function lighten(color, percent) {
  return lightenDarken(color, percent);
}

export function darken(color, percent) {
  return lightenDarken(color, -percent);
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/colors.js